/* Progressive enhancement: content and shopping remain usable without motion. */
(() => {
  const toggle = document.querySelector('.bh-menu-toggle');
  const menu = document.getElementById('bh-mobile-menu');
  let menuScrollLock = null;
  function lockMenuScroll() {
    if (menuScrollLock) return;
    const body = document.body, root = document.documentElement;
    const properties = ['position', 'top', 'left', 'width', 'overflow'];
    menuScrollLock = { x: window.scrollX, y: window.scrollY,
      body: properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]),
      rootOverflow: root.style.getPropertyValue('overflow'), rootOverflowPriority: root.style.getPropertyPriority('overflow') };
    root.classList.add('bh-mobile-nav-open');
    root.style.setProperty('overflow', 'hidden');
    body.style.setProperty('position', 'fixed');
    body.style.setProperty('top', -menuScrollLock.y + 'px');
    body.style.setProperty('left', -menuScrollLock.x + 'px');
    body.style.setProperty('width', '100%');
    body.style.setProperty('overflow', 'hidden');
  }
  function unlockMenuScroll() {
    if (!menuScrollLock) return;
    const saved = menuScrollLock, body = document.body, root = document.documentElement;
    menuScrollLock = null;
    saved.body.forEach(([name, value, priority]) => value ? body.style.setProperty(name, value, priority) : body.style.removeProperty(name));
    root.classList.remove('bh-mobile-nav-open');
    saved.rootOverflow ? root.style.setProperty('overflow', saved.rootOverflow, saved.rootOverflowPriority) : root.style.removeProperty('overflow');
    const behavior = root.style.getPropertyValue('scroll-behavior'), priority = root.style.getPropertyPriority('scroll-behavior');
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(saved.x, saved.y);
    behavior ? root.style.setProperty('scroll-behavior', behavior, priority) : root.style.removeProperty('scroll-behavior');
  }
  function closeMenu(returnFocus = false) {
    if (!toggle || !menu) return;
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    toggle.textContent = 'Menu';
    unlockMenuScroll();
    if (returnFocus) toggle.focus({ preventScroll: true });
  }
  toggle?.addEventListener('click', () => {
    if (!menu) return;
    if (toggle.getAttribute('aria-expanded') === 'true') { closeMenu(); return; }
    lockMenuScroll();
    menu.hidden = false;
    menu.scrollTop = 0;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    toggle.textContent = 'Close';
  });
  menu?.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', event => {
    if (!menu || menu.hidden) return;
    if (event.key === 'Escape') { closeMenu(true); return; }
    if (event.key !== 'Tab') return;
    const controls = [...toggle.closest('.bh-header-wrap').querySelectorAll('a, button')].filter(element => element.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', event => { if (!event.target.closest('.bh-header-wrap')) closeMenu(); });
  window.matchMedia('(min-width: 1051px)').addEventListener('change', event => { if(event.matches) closeMenu(); });
  window.addEventListener('pagehide', () => closeMenu());
  function reveal(root = document) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('bh-motion');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.remove('bh-reveal-pending'); observer.unobserve(entry.target); }
    }), { threshold: 0.05, rootMargin: '0px 0px 40px 0px' });
    root.querySelectorAll('[data-bh-reveal]').forEach(element => {
      if (element.getBoundingClientRect().top > window.innerHeight) element.classList.add('bh-reveal-pending');
      observer.observe(element);
    });
  }
  reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
})();

/* Native Shopify contact delivery; accessible inline validation only. */
(() => {
 const form = document.querySelector('.bh-wholesale-form');
 if (!form) return;
 function updateField(field) {
  if (!field.matches('input:not([type="hidden"]), select, textarea')) return;
  const errorId = field.getAttribute('aria-describedby');
  const message = errorId && document.getElementById(errorId);
  if (!message || !message.classList.contains('bh-field-error')) return;
  const valid = field.validity.valid;
  field.toggleAttribute('aria-invalid', !valid);
  if (!valid) field.setAttribute('aria-invalid', 'true');
  message.hidden = valid;
  message.textContent = valid ? '' : field.validationMessage;
 }
 form.addEventListener('invalid', event => updateField(event.target), true);
 ['input', 'change'].forEach(type => form.addEventListener(type, event => {
  if (event.target.hasAttribute('aria-invalid')) updateField(event.target);
 }));
 const result = form.querySelector('.bh-form-success, .bh-form-server-errors');
 result?.focus({ preventScroll: true });
})();

var SubscriptionModule = class extends HTMLElement {
  connectedCallback() {
    this._radioButtons = Array.from(this.querySelectorAll('input[type="radio"]'));
    this._selectElement = this.querySelector("[data-selling-plan-select]");
    this._hiddenInput = this.querySelector("[data-selling-plan-input]");
    this._subscriptionPriceElement = this.querySelector("[data-subscription-price]");
    this._subscriptionCompareElement = this.querySelector("[data-subscription-compare]");
    this._onChangeListener = () => {
      this._syncState();
      this.querySelector("[data-subscription-plan-notice]")?.remove();
    };
    this._onClickListener = this._onOptionClicked.bind(this);
    this.addEventListener("change", this._onChangeListener);
    this.addEventListener("click", this._onClickListener);
    const purchaseParams = new URLSearchParams(window.location.search);
    if (purchaseParams.get("purchase") === "subscription") {
      const requestedPlan = purchaseParams.get("selling_plan");
      const requestedPlanAvailable = !purchaseParams.has("selling_plan") || Boolean(requestedPlan && (
        Array.from(this._selectElement?.options || []).some(option => option.value === requestedPlan) ||
        this._hiddenInput?.value === requestedPlan
      ));
      const radio = this.querySelector(requestedPlanAvailable ? 'input[value="subscription"]' : 'input[value="one-time"]');
      if (radio) radio.checked = true;
      if (!requestedPlanAvailable && !this.querySelector("[data-subscription-plan-notice]")) {
        const notice = document.createElement("p");
        notice.setAttribute("data-subscription-plan-notice", "");
        notice.setAttribute("role", "status");
        notice.className = "text-subdued";
        notice.textContent = "That delivery option is no longer available. Choose a current subscription option or continue with a one-time purchase.";
        this.append(notice);
      }
    }
    this._syncState();
  }
  disconnectedCallback() {
    this.removeEventListener("change", this._onChangeListener);
    this.removeEventListener("click", this._onClickListener);
  }
  _onOptionClicked(event) {
    if (event.target.closest("a, button, select, option, input, label")) {
      return;
    }
    const option = event.target.closest(".subscription-module__option");
    const radio = option?.querySelector('input[type="radio"]');
    if (!radio || radio.checked) {
      return;
    }
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }
  _syncState() {
    const selectedRadio = this.querySelector('input[type="radio"]:checked');
    const subscriptionSelected = selectedRadio?.value === "subscription";
    this.querySelectorAll(".subscription-module__option").forEach((option) => {
      option.classList.toggle("is-selected", option.getAttribute("data-option-type") === (subscriptionSelected ? "subscription" : "one-time"));
    });
    if (this._selectElement) {
      this._selectElement.disabled = !subscriptionSelected;
      const selectedOption = this._selectElement.options[this._selectElement.selectedIndex];
      if (selectedOption) {
        this._subscriptionPriceElement.textContent = selectedOption.getAttribute("data-price");
        const savingsPercent = Number(selectedOption.getAttribute("data-savings-percent") || 0);
        const savingsBadge = this.querySelector("[data-subscription-savings-badge]");
        const savingsCopy = this.querySelector("[data-subscription-savings]");
        if (savingsBadge) {
          savingsBadge.textContent = "Save " + savingsPercent + "%";
          savingsBadge.hidden = savingsPercent <= 0;
        }
        if (savingsCopy) {
          savingsCopy.textContent = selectedOption.getAttribute("data-savings-text") || "";
          savingsCopy.hidden = Number(selectedOption.getAttribute("data-savings-cents") || 0) <= 0;
        }
        if (this._subscriptionCompareElement) {
          const comparePrice = selectedOption.getAttribute("data-compare");
          this._subscriptionCompareElement.textContent = comparePrice;
          this._subscriptionCompareElement.hidden = !comparePrice || comparePrice === selectedOption.getAttribute("data-price");
        }
      }
    }
    if (this._hiddenInput) {
      this._hiddenInput.disabled = !subscriptionSelected;
    }
  }
};
if (!window.customElements.get("subscription-module")) {
  window.customElements.define("subscription-module", SubscriptionModule);
}


/* Scroll-linked product movement. Scrolling always stays native. */
(() => {
 const header = document.querySelector('.bh-header-wrap');
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 let products = [], queued = false;
 const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
 function collect() {
  products = [...document.querySelectorAll('[data-bh-product-motion]')];
  document.querySelectorAll('.bh-family-grid, .bh-routine-grid').forEach(group => {
   [...group.children].forEach((child, index) => child.style.setProperty('--bh-reveal-delay', `${Math.min(index, 2) * 90}ms`));
  });
  schedule();
 }
 function paint() {
  queued = false;
  const y = window.scrollY, height = window.innerHeight;
  header?.classList.toggle('is-scrolled', y > 45);
  products.forEach(stage => {
   if (reduced.matches || stage.classList.contains('bh-golden-single-stage')) {
    ['--bh-product-y', '--bh-product-turn', '--bh-product-scale'].forEach(name => stage.style.removeProperty(name));
    return;
   }
   const story = stage.closest('[data-bh-discovery]');
   const rect = (story || stage).getBoundingClientRect();
   if (rect.bottom < -100 || rect.top > height + 100) return;
   const progress = story
    ? clamp((height * .65 - rect.top) / Math.max(rect.height - height * .25, 1), 0, 1)
    : clamp((height - rect.top) / (height + rect.height), 0, 1);
   const range = window.innerWidth < 750 ? 24 : 42;
   stage.style.setProperty('--bh-product-y', `${((.5 - progress) * range).toFixed(2)}px`);
   stage.style.removeProperty('--bh-product-turn');
   stage.style.setProperty('--bh-product-scale', (.965 + progress * .055).toFixed(4));
  });
 }
 function schedule() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
 window.addEventListener('scroll', schedule, { passive: true });
 window.addEventListener('resize', schedule);
 reduced.addEventListener('change', schedule);
 document.addEventListener('shopify:section:load', collect);
 collect();
})();

/* Science benefit links become keyboard-operable tabs; all content remains without JS. */
(() => {
 function initScience(root = document) {
  root.querySelectorAll('[data-bh-benefit-explorer]').forEach(explorer => {
   if (explorer.classList.contains('is-ready')) return;
   const list = explorer.querySelector('[data-bh-benefit-tabs]');
   const tabs = [...explorer.querySelectorAll('[data-bh-benefit-tab]')];
   const panels = [...explorer.querySelectorAll('[data-bh-benefit-panel]')];
   if (!list || !tabs.length || tabs.length !== panels.length) return;
   list.setAttribute('role', 'tablist');
   tabs.forEach((tab, i) => {
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', panels[i].id);
    panels[i].setAttribute('role', 'tabpanel');
    panels[i].setAttribute('aria-labelledby', tab.id);
    panels[i].tabIndex = 0;
   });
   function select(index, focus = false) {
    tabs.forEach((tab, i) => {
     tab.setAttribute('aria-selected', String(i === index));
     tab.tabIndex = i === index ? 0 : -1;
     panels[i].hidden = i !== index;
    });
    if (focus) tabs[index].focus({preventScroll:true});
   }
   tabs.forEach((tab, i) => {
    tab.addEventListener('click', event => {event.preventDefault(); select(i);});
    tab.addEventListener('keydown', event => {
     if (event.key === ' ' || event.key === 'Enter') {event.preventDefault();select(i);return;}
     const actions = {ArrowRight:(i+1)%tabs.length,ArrowLeft:(i-1+tabs.length)%tabs.length,Home:0,End:tabs.length-1};
     if (Object.prototype.hasOwnProperty.call(actions,event.key)) {event.preventDefault();select(actions[event.key],true);}
    });
   });
   function readHash() {
    const index = panels.findIndex(panel => '#' + panel.id === window.location.hash);
    if (index >= 0) select(index);
   }
   select(0);
   readHash();
   explorer.classList.add('is-ready');
   window.addEventListener('hashchange',readHash);
  });
 }
 initScience();
 document.addEventListener('shopify:section:load',event => initScience(event.target));
})();

/* Science: native scrolling animates diagrams, never the product/copy layout. */
(() => {
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 let diagrams = [], queued = false, revealObserver;
 const clamp = value => Math.max(0, Math.min(1, value));
 function paintScience() {
  queued = false;
  diagrams.forEach(story => {
   const visual = story.querySelector('.bh-formula-visual');
   if (!visual) return;
   const rect = visual.getBoundingClientRect();
   if (story.dataset.capsuleOpening !== undefined) return; const progress = reduced.matches ? 1 : clamp((innerHeight * .94 - rect.top) / (innerHeight * .66));
   story.style.setProperty('--science-open', progress.toFixed(4));
  });
 }
 function scheduleScience() {
  if (!queued) { queued = true; requestAnimationFrame(paintScience); }
 }
 function initScienceMotion() {
  const page = document.querySelector('.bh-science-page');
  if (!page) return;
  diagrams = [...page.querySelectorAll('[data-bh-science-motion]')];
  page.classList.add('bh-science-motion-ready');
  revealObserver?.disconnect();
  if ('IntersectionObserver' in window && !reduced.matches) {
   revealObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
     if (entry.isIntersecting) {
      entry.target.classList.add('is-in-view');
      revealObserver.unobserve(entry.target);
     }
    });
   }, { threshold:.12, rootMargin:'0px 0px -25px 0px' });
   page.querySelectorAll('[data-bh-science-reveal]').forEach(item => revealObserver.observe(item));
  } else {
   page.querySelectorAll('[data-bh-science-reveal]').forEach(item => item.classList.add('is-in-view'));
  }
  paintScience();
 }
 window.addEventListener('scroll',scheduleScience,{passive:true});
 window.addEventListener('resize',scheduleScience);
 reduced.addEventListener('change',initScienceMotion);
 document.addEventListener('shopify:section:load',initScienceMotion);
 initScienceMotion();
})();

// Keep the Giving Back headline visible instead of inheriting the native split-line reveal.
if (document.body.classList.contains('bh-page-charity')) {
  document.querySelectorAll('p.h1').forEach(original => {
    const heading = document.createElement('h1');
    heading.className = 'bh-charity-title';
    heading.textContent = original.textContent.trim();
    original.replaceWith(heading);
  });
}

// Filter the existing rendered archive. Nothing is changed in Shopify article records.
document.querySelectorAll('[data-bh-journal]').forEach(journal => {
  const controls=journal.querySelector('[data-journal-controls]');
  const input=journal.querySelector('[data-journal-search]');
  const grid=journal.querySelector('[data-journal-grid]');
  const cards=[...journal.querySelectorAll('[data-journal-card]')];
  const buttons=[...journal.querySelectorAll('[data-journal-topic]')];
  const count=journal.querySelector('[data-journal-count]');
  const empty=journal.querySelector('[data-journal-empty]');
  let topic='all';
  const normalize=text=>text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'');
  const update=()=>{
    const terms=normalize(input.value.trim()).split(/\s+/).filter(Boolean);
    let visible=0;
    cards.forEach(card=>{
      const text=normalize(card.dataset.search);
      const matches=(topic==='all'||card.dataset.topic===topic)&&terms.every(term=>text.includes(term));
      card.hidden=!matches; if(matches)visible++;
    });
    const filtered=topic!=='all'||terms.length>0;
    grid.classList.toggle('is-filtered',filtered);
    count.textContent=filtered?`${visible} ${visible===1?'story':'stories'} found`:`${cards.length} stories to explore`;
    empty.hidden=visible>0;
    buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.journalTopic===topic)));
  };
  buttons.forEach(button=>button.addEventListener('click',()=>{topic=button.dataset.journalTopic;update();}));
  input.addEventListener('input',update);
  input.addEventListener('search',update);
  journal.querySelector('[data-journal-reset]').addEventListener('click',()=>{topic='all';input.value='';update();buttons[0].focus();});
  controls.hidden=false;update();
});

// Routine calculations use the published serving chart and live selling-plan allocations.
(() => {
 const money=(cents,currency)=>new Intl.NumberFormat('en-US',{style:'currency',currency}).format(cents/100);
 const cadenceFrom=name=>{
  const match=String(name||'').match(/\b(\d+)\s*[-–]?\s*(day|week|month)s?\b/i);
  if(!match||Number(match[1])<1)return {days:0,label:''};
  const count=Number(match[1]),unit=match[2].toLowerCase();
  const days=unit==='week'?count*7:unit==='day'?count:0;
  const weeks=days&&days%7===0?days/7:0;
  return {days,label:weeks?`${weeks} ${weeks===1?'week':'weeks'}`:`${count} ${unit}${count===1?'':'s'}`};
 };
 document.querySelectorAll('[data-bh-routine-builder]').forEach(builder=>{
  const form=builder.querySelector('[data-routine-form]'), dogs=builder.querySelector('[data-routine-dogs]');
  const result=builder.querySelector('[data-routine-result]'), template=builder.querySelector('[data-dog-template]');
  const add=builder.querySelector('[data-add-dog]');
  const currency=builder.dataset.currency;
  const plans=[...builder.querySelectorAll('[data-plan-id]')].map(el=>({id:el.dataset.planId,...cadenceFrom(el.dataset.planName),price:Number(el.dataset.planPrice)})).filter(plan=>plan.days>0).sort((a,b)=>a.days-b.days);
  let id=0;
  const addDog=()=>{
   if(dogs.children.length>=6)return;result.hidden=true;
   const dog=template.content.firstElementChild.cloneNode(true);id++;
   ['name','weight','age','food'].forEach(key=>{const input=dog.querySelector(`[data-dog-${key}]`);input.id=`RoutineDog${id}-${key}`;dog.querySelector(`[data-label="${key}"]`).htmlFor=input.id;});
   const name=dog.querySelector('[data-dog-name]');
   name.addEventListener('input',()=>{dog.querySelector('legend').textContent=name.value.trim()||'Your dog';});
   dog.querySelector('[data-remove-dog]').addEventListener('click',()=>{if(dogs.children.length<=1)return;dog.remove();add.hidden=false;result.hidden=true;add.focus();});
   dog.addEventListener('input',()=>{result.hidden=true;});dog.addEventListener('change',()=>{result.hidden=true;});
   dogs.append(dog);add.hidden=dogs.children.length>=6;if(dogs.children.length>1)name.focus();
  };
  add.addEventListener('click',addDog);addDog();
  form.addEventListener('submit',event=>{
   event.preventDefault();if(!form.reportValidity())return;
   const entries=[...dogs.children].map(dog=>{const value=key=>dog.querySelector(`[data-dog-${key}]`).value;const weight=Number(value('weight'));return{name:value('name').trim()||'Your dog',weight,grams:weight<50?1:weight<=100?1.5:2,stage:value('age'),food:value('food')};});
   const total=entries.reduce((sum,dog)=>sum+dog.grams,0);const oneBagDays=90/total;
   const bags=plans.length?Math.max(1,Math.ceil(total*plans[0].days/90)):1;
   const plan=[...plans].reverse().find(p=>p.days<=oneBagDays*bags)||plans[0];
   builder.querySelector('[data-routine-title]').textContent=entries.length===1?`${entries[0].name}’s daily little thing.`:'A routine for your whole crew.';
   const portions=builder.querySelector('[data-routine-portions]');portions.replaceChildren();
   entries.forEach(dog=>{const article=document.createElement('article'),copy=document.createElement('div'),heading=document.createElement('h3'),p=document.createElement('p'),dose=document.createElement('strong');heading.textContent=dog.name;const stage=dog.stage==='puppy'?' For puppies, confirm suitability with your vet before starting.':'';p.textContent=`${dog.weight} lb · Sprinkle into ${dog.food} once daily.${stage}`;dose.textContent=`${dog.grams===1.5?'1½':dog.grams} ${dog.grams===1?'scoop':'scoops'} per day`;copy.append(heading,p);article.append(copy,dose);portions.append(article);});
   builder.querySelector('[data-routine-days]').textContent=Number.isInteger(oneBagDays)?oneBagDays:Math.floor(oneBagDays);
   builder.querySelector('[data-routine-daily]').textContent=money((plan?plan.price:Number(builder.dataset.price))/oneBagDays,currency);
   builder.querySelector('[data-routine-frequency]').textContent=plan?plan.label:'One-time';
   builder.querySelector('[data-routine-order]').textContent=plan?`${bags} ${bags===1?'bag':'bags'} · ${money(plan.price*bags,currency)} every ${plan.label}`:`${money(Number(builder.dataset.price),currency)} per bag`;
   builder.querySelector('[data-routine-explanation]').textContent=`At ${total} g a day for ${entries.length===1?'your dog':`${entries.length} dogs`}, ${bags} ${bags===1?'bag supplies':'bags supply'} about ${Math.floor(90*bags/total)} days. ${plan?'This frequency schedules the next order before that supply runs out. Allow time for shipping and adjust the date in Recharge as needed.':'Review the available purchase options on the product page.'}`;
   const url=new URL(builder.dataset.productUrl,location.origin);if(plan){url.searchParams.set('purchase','subscription');url.searchParams.set('selling_plan',plan.id);url.searchParams.set('quantity',bags);url.searchParams.set('daily_grams',total);url.searchParams.set('dogs',entries.length);}builder.querySelector('[data-routine-shop]').href=url.pathname+url.search;
   result.hidden=false;result.focus({preventScroll:true});result.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  });
  builder.querySelector('[data-routine-edit]').addEventListener('click',()=>{form.querySelector('input').focus();});
 });
 document.querySelectorAll('[data-bh-buying-clarity]').forEach(panel=>{
  const info=panel.closest('.product-info')||panel.parentElement;
  const module=info.querySelector('subscription-module')||document.querySelector('subscription-module');
  const days=panel.querySelector('[data-bag-days]');
  const quantity=info.querySelector('input[name="quantity"]');
  const routineParams=new URLSearchParams(location.search), grams=Number(routineParams.get('daily_grams')), count=Number(routineParams.get('dogs'));
  if(grams>=1&&grams<=12&&Number.isInteger(grams*2)&&Number.isInteger(count)&&count>=1&&count<=6){const option=document.createElement('option');option.value=90/grams;option.textContent=`Your routine · ${grams} g daily for ${count===1?'one dog':count+' dogs'}`;days.append(option);days.value=option.value;}

  const update=()=>{const subscription=module?.querySelector('input[value="subscription"]:checked');const plan=module?.querySelector('[data-selling-plan-select]')?.selectedOptions[0]||module?.querySelector('[data-selling-plan-input]');const price=subscription&&plan?Number(plan.dataset.priceCents):Number(panel.dataset.price);const frequency=plan?cadenceFrom(plan.dataset.planName||plan.textContent).label:'';panel.querySelector('[data-bag-duration]').textContent=`${Math.floor(Number(days.value))} days`;panel.querySelector('[data-bag-daily]').textContent=money(price/Number(days.value),panel.dataset.currency);const count=Math.max(1,Number(quantity?.value)||1);panel.querySelector('[data-charge-summary]').textContent=subscription?`${count} ${count===1?'bag':'bags'} · ${money(price*count,panel.dataset.currency)} per delivery${frequency?', every '+frequency:', at your selected interval'}. Skip, reschedule, or cancel in your account.`:`${count} ${count===1?'bag':'bags'} · ${money(price*count,panel.dataset.currency)}, one time.`;};
  days.addEventListener('change',update);module?.addEventListener('change',update);quantity?.addEventListener('change',update);quantity?.addEventListener('input',update);update();
 });
 // Optional plan handoff only accepts an allocation already present in the product selector.
 const params=new URLSearchParams(location.search),requested=params.get('selling_plan');
 const module=document.querySelector('subscription-module'),select=module?.querySelector('[data-selling-plan-select]');
 if(params.get('purchase')==='subscription'&&requested&&select&&[...select.options].some(option=>option.value===requested)){
  select.value=requested;select.dispatchEvent(new Event('change',{bubbles:true}));
  const qty=Number(params.get('quantity'));const quantity=document.querySelector('input[name="quantity"]');if(quantity&&Number.isInteger(qty)&&qty>=1&&qty<=12){quantity.value=qty;quantity.dispatchEvent(new Event('change',{bubbles:true}));}
 }
 // Video playback is deliberate, with native accessible controls and no forced autoplay.
 document.querySelectorAll('.bh-film-frame video').forEach(video=>{const caption=video.parentElement.querySelector('.bh-film-caption');video.addEventListener('play',()=>{caption.hidden=true;});video.addEventListener('ended',()=>{caption.hidden=false;});});
})();

document.querySelectorAll('[data-capsule-serving]').forEach(section=>{
 const buttons=[...section.querySelectorAll('[data-capsule-method]')];
 buttons.forEach(button=>button.addEventListener('click',()=>{section.dataset.method=button.dataset.capsuleMethod;buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));section.querySelector('[role="img"]').setAttribute('aria-label',button.dataset.capsuleMethod==='whole'?'Illustration of a closed capsule that can be given whole':'Illustration of a capsule opening to sprinkle its contents');}));
});

/* Keep the full review widget available without extending the initial product page. */
(() => {
 const reviews = document.getElementById('meal-reviews');
 if (!reviews) return;
 const openReviews = () => { reviews.open = true; };
 const reviewLabel = reviews.querySelector('[data-review-toggle-label]');
 reviews.addEventListener('toggle', () => { if (reviewLabel) reviewLabel.textContent = reviews.open ? 'Close reviews' : 'Read reviews'; });
 const openHashTarget = () => {
  if (location.hash === '#judgeme_product_reviews' || location.hash === '#meal-reviews') {
   openReviews();
   reviews.scrollIntoView({block:'start'});
  } else if (location.hash === '#daily-routine') {
   const directions = document.getElementById('daily-routine');
   if (directions) directions.open = true;
  }
 };
 document.addEventListener('click', event => {
  if (event.target.closest('.jdgm-preview-badge, a[href$="#judgeme_product_reviews"], a[href="#meal-reviews"]')) {
   event.preventDefault();
   event.stopPropagation();
   openReviews();
   reviews.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
 }, true);
 window.addEventListener('hashchange', openHashTarget);
 openHashTarget();
})();

/* The approved pouch stays separate from generated scenery. */
(() => {
  const hero = document.querySelector('[data-bh-motion-hero]');
  const video = hero?.querySelector('[data-bh-hero-video]');
  const button = hero?.querySelector('[data-bh-motion-toggle]');
  if (!hero || !video || !button || !video.dataset.src) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 750px)');
  const connection = navigator.connection;
  let inView = true;
  let userPaused = false;
  let failed = false;
  let playPending = false;
  let activeSource = '';

  function eligible() {
    return !!sourceForSize() && !reduced.matches && !connection?.saveData && !failed;
  }
  function sourceForSize() {
    return desktop.matches ? video.dataset.src : video.dataset.mobileSrc;
  }
  function updateControl() {
    button.hidden = !eligible() || !video.readyState;
    button.textContent = video.paused ? 'Play motion' : 'Pause motion';
    button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
  }
  function sync() {
    const enabled = eligible();
    if (!enabled || !inView || document.hidden || userPaused) {
      video.pause();
      if (!enabled) hero.classList.remove('is-video-ready');
      updateControl();
      return;
    }
    const source = sourceForSize();
    if (activeSource !== source) {
      video.pause();
      hero.classList.remove('is-video-ready');
      activeSource = source;
      video.src = source;
      video.load();
    }
    if (!video.paused || playPending) return;
    playPending = true;
    const requestedSource = activeSource;
    video.play().catch(error => {
      if (activeSource === requestedSource && error.name === 'NotAllowedError') userPaused = true;
    }).finally(() => {
      playPending = false;
      if (!eligible() || !inView || document.hidden || userPaused) video.pause();
      updateControl();
      if (activeSource !== requestedSource) sync();
    });
  }
  video.addEventListener('playing', () => {
    if (eligible()) hero.classList.add('is-video-ready');
    updateControl();
  });
  video.addEventListener('loadeddata', updateControl);
  video.addEventListener('pause', updateControl);
  video.addEventListener('error', () => {
    failed = true;
    hero.classList.remove('is-video-ready');
    updateControl();
  });
  button.addEventListener('click', () => {
    userPaused = !video.paused;
    sync();
  });
  reduced.addEventListener('change', sync);
  desktop.addEventListener('change', sync);
  connection?.addEventListener?.('change', sync);
  document.addEventListener('visibilitychange', sync);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      sync();
    }, {threshold: 0.08}).observe(hero);
  }
  sync();
})();

/* Homepage details animate once on entry; content stays visible without JavaScript. */
(() => {
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 let observer;
 function initHomeDetails() {
  const home = document.querySelector('.bh-mode-home');
  if (!home) return;
  const sections = [...home.querySelectorAll('[data-bh-detail-motion]')];
  sections.forEach(section => {
   section.querySelectorAll('.bh-ingredient-list>div:not(.bh-formula-key), .bh-film-steps>span, .bh-golden-facts>span').forEach((item, index) => item.style.setProperty('--bh-detail-order', index));
  });
  observer?.disconnect();
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  observer = new IntersectionObserver(entries => {
   entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('is-detail-visible');
    observer.unobserve(entry.target);
   });
  }, {threshold:0.22, rootMargin:'0px 0px -5% 0px'});
  sections.filter(section => !section.classList.contains('is-detail-visible')).forEach(section => observer.observe(section));
 }
 initHomeDetails();
 reduced.addEventListener('change', initHomeDetails);
 document.addEventListener('shopify:section:load', initHomeDetails);
})();

/* v77: draft-only account sandbox and lightweight product discovery. No service requests. */
(() => {
 const iframe=document.querySelector('[data-bh-account-sandbox]');
 if(iframe){
  window.addEventListener('message',event=>{
   if(event.source!==iframe.contentWindow||event.data?.type!=='brothhh-preview-height-v77')return;
   const height=Number(event.data.height);if(Number.isFinite(height)&&height>=300&&height<20000)iframe.style.height=`${Math.ceil(height)+3}px`;
  });
 }
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('.bh-formula').forEach(formula=>{
  const list=formula.querySelector('.bh-ingredient-list');
  const rows=list?[...list.children].filter(el=>el.tagName==='DIV'&&!el.classList.contains('bh-formula-key')):[];
  if(!rows.length||formula.dataset.spotlightReady)return;formula.dataset.spotlightReady='true';
  const aside=formula.firstElementChild,spotlight=document.createElement('div');spotlight.className='bh-formula-spotlight';
  spotlight.innerHTML='<div class="bh-spotlight-copy"><span data-spotlight-name></span><strong data-spotlight-amount></strong></div><div class="bh-spotlight-meter" aria-hidden="true"><span></span></div><small>Explore each ingredient. Measured per 1 g.</small>';
  aside.append(spotlight);
  const activate=index=>{
   const row=rows[index],name=row.querySelector('span').textContent,amount=row.querySelector('span:nth-child(2)').textContent;
   rows.forEach((r,i)=>{r.classList.toggle('is-ingredient-active',i===index);r.querySelector('button')?.setAttribute('aria-pressed',String(i===index));});
   spotlight.querySelector('[data-spotlight-name]').textContent=name;
   spotlight.querySelector('[data-spotlight-amount]').textContent=amount;
   spotlight.style.setProperty('--spotlight-share',index===0?'50%':'10%');
  };
  rows.forEach((row,index)=>{
   const button=document.createElement('button');button.type='button';button.className='bh-ingredient-hit';button.setAttribute('aria-label',`Explore ${row.querySelector('span').textContent}, ${row.querySelector('span:nth-child(2)').textContent} per gram`);button.setAttribute('aria-pressed','false');row.append(button);
   button.addEventListener('click',()=>activate(index));button.addEventListener('focus',()=>activate(index));row.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')activate(index);});
  });activate(0);
 });
 document.querySelectorAll('.bh-capsule-story').forEach(story=>{
  const visual=story.querySelector('.bh-capsule-visual'),ledger=story.querySelector('.bh-formula-ledger');if(!visual||!ledger||story.dataset.capsuleReady)return;story.dataset.capsuleReady='true';
  const controls=document.createElement('div');controls.className='bh-capsule-controls';controls.innerHTML='<button type="button" aria-pressed="false" data-capsule-toggle>Open the capsule</button><label>Explore inside<input type="range" min="0" max="100" value="0" step="1" aria-label="Capsule opening" aria-valuetext="Closed capsule"></label>';
  visual.append(controls);story.classList.add('bh-capsule-interactive');story.dataset.capsuleOpening='0';story.style.setProperty('--science-open','0','important');
  const toggle=controls.querySelector('button'),range=controls.querySelector('input');let frame=0,value=0;
  function set(next){value=next;story.dataset.capsuleOpening=String(next/100);story.style.setProperty('--science-open',String(next/100),'important');range.value=String(Math.round(next));range.setAttribute('aria-valuetext',next<2?'Closed capsule':next>98?'Open capsule':`Capsule ${Math.round(next)} percent open`);toggle.textContent=next>50?'Close the capsule':'Open the capsule';toggle.setAttribute('aria-pressed',String(next>50));}
  function move(target){cancelAnimationFrame(frame);if(reduced.matches){set(target);return;}const from=value,start=performance.now();function step(now){const t=Math.min(1,(now-start)/900),ease=1-Math.pow(1-t,3);set(from+(target-from)*ease);if(t<1)frame=requestAnimationFrame(step);}frame=requestAnimationFrame(step);}
  toggle.addEventListener('click',()=>move(value>50?0:100));range.addEventListener('input',()=>{cancelAnimationFrame(frame);set(Number(range.value));});
  const tones=['#b99553','#af718e','#c3a66e'];
  [...ledger.children].forEach((row,i)=>{
   row.classList.add('bh-capsule-ingredient');const button=document.createElement('button');button.type='button';button.className='bh-capsule-ingredient-hit';button.setAttribute('aria-label',`Explore ${row.querySelector('dt').textContent}, ${row.querySelector('dd').textContent}`);button.setAttribute('aria-pressed','false');row.append(button);
   button.addEventListener('click',()=>{[...ledger.children].forEach(r=>{r.classList.remove('is-capsule-ingredient-active');r.querySelector('button')?.setAttribute('aria-pressed','false');});row.classList.add('is-capsule-ingredient-active');button.setAttribute('aria-pressed','true');story.style.setProperty('--capsule-grain-color',tones[i]);move(100);});
  });
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){move(100);observer.disconnect();}},{threshold:.6});observer.observe(visual);}
  reduced.addEventListener('change',()=>{cancelAnimationFrame(frame);set(value>50?100:0);});
 });
})();
(() => {
 const waitlist = document.querySelector('.bh-mode-goldengut #golden-waitlist');
 const hero = waitlist?.closest('.bh-gg60-hero');
 if (!hero) return;
 const desktop = matchMedia('(min-width:750px)');
 const header = document.querySelector('.bh-header-wrap');
 let active = false;
 let interacted = false;
 let frame = 0;
 let deadline = 0;
 const updateOffset = () => {
  if (!desktop.matches) { waitlist.style.removeProperty('scroll-margin-top'); return; }
  const headerHeight = header?.getBoundingClientRect().height || 0;
  const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
  const offset = waitlist.getBoundingClientRect().top - hero.getBoundingClientRect().top;
  waitlist.style.setProperty('scroll-margin-top',`${offset + headerHeight + 16 - scrollPadding}px`,'important');
 };
 const stopAlignment = () => {
  active = false;
  cancelAnimationFrame(frame);
  frame = 0;
  clearTimeout(deadline);
 };
 const alignMobile = () => {
  frame = 0;
  if (!active || desktop.matches || location.hash !== '#golden-waitlist') return;
  const headerHeight = header?.getBoundingClientRect().height || 0;
  const top = Math.max(0, window.scrollY + waitlist.getBoundingClientRect().top - headerHeight - 12);
  if (Math.abs(window.scrollY - top) > 1) window.scrollTo({top,behavior:'instant'});
 };
 const queueAlignment = () => {
  if (!active || frame) return;
  frame = requestAnimationFrame(alignMobile);
 };
 const beginMobileAlignment = () => {
  stopAlignment();
  if (desktop.matches || location.hash !== '#golden-waitlist') return;
  active = true;
  interacted = false;
  queueAlignment();
  deadline = setTimeout(stopAlignment,4000);
 };
 const alignEntry = () => {
  updateOffset();
  if (desktop.matches && location.hash === '#golden-waitlist') {
   requestAnimationFrame(() => waitlist.scrollIntoView({block:'start',behavior:'instant'}));
  } else {
   beginMobileAlignment();
  }
 };
 const userTookOver = () => { interacted = true; stopAlignment(); };
 ['touchstart','pointerdown','wheel','keydown'].forEach(type => window.addEventListener(type,userTookOver,{passive:true}));
 waitlist.addEventListener('focusin',userTookOver);
 document.addEventListener('click',event => {
  if (desktop.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  const url = new URL(link.href,location.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || url.hash !== '#golden-waitlist') return;
  requestAnimationFrame(beginMobileAlignment);
 });
 updateOffset();
 if (document.readyState === 'complete') alignEntry();
 else {
  beginMobileAlignment();
  window.addEventListener('load',() => { if (desktop.matches || !interacted) alignEntry(); },{once:true});
 }
 window.addEventListener('pageshow',event => { if (event.persisted) alignEntry(); });
 window.addEventListener('hashchange',alignEntry);
 window.addEventListener('resize',() => { updateOffset(); queueAlignment(); },{passive:true});
 desktop.addEventListener('change',() => { updateOffset(); if (desktop.matches) stopAlignment(); });
 if (document.fonts?.ready) document.fonts.ready.then(queueAlignment);
 if ('ResizeObserver' in window) {
  const observer = new ResizeObserver(() => { updateOffset(); queueAlignment(); });
  observer.observe(hero);
  if (header) observer.observe(header);
 }
})();
